import { Pipe, PipeTransform } from '@angular/core';
import { Article } from "../article/article";
import { categories } from "../../assets/categories";

@Pipe({
  name: 'mainCategoryFilter'
})
export class MainCategoryFilterPipe implements PipeTransform {

  transform(articles:Array<Article>, mainCategory:string):Array<Article> {
    if (!articles) return null;

    let filteredArticles;

    switch (mainCategory) {
      case "Bücher":
        filteredArticles = articles.filter(article => categories.subcategories.books.indexOf(article.category) != -1);
        break;
      case "Kartografie":
        filteredArticles = articles.filter(article => categories.subcategories.maps.indexOf(article.category) != -1);
        break;
      case "Postkarten":
        filteredArticles = articles.filter(article => article.category == "Postkarten");
        break;
      default:
        filteredArticles = articles;
    }

    return filteredArticles;
  }

}



// WEBPACK FOOTER //
// ./src/app/filter/main-category-filter.pipe.ts